<script setup>
// Uma seção da Nexus IA (um item do menu): título e o componente da seção. Se
// a empresa não tem o recurso da seção (endereço digitado ou favorito antigo),
// explica em vez de mostrar uma tela quebrada.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import AvisosManutencao from './AvisosManutencao.vue';
import GatewayEmpresa from './GatewayEmpresa.vue';
import RelatorioDisparos from './RelatorioDisparos.vue';
import WhatsappUso from './WhatsappUso.vue';
import { SECOES, useRecursos } from './recursos';
import messages from './i18n';

const props = defineProps({
  secao: { type: String, required: true },
});

const COMPONENTES = {
  DISPAROS: RelatorioDisparos,
  GATEWAY: GatewayEmpresa,
  MANUTENCAO: AvisosManutencao,
  USO: WhatsappUso,
};

const { t } = useI18n({ messages });
const { accountId } = useAccount();
const recursos = useRecursos();

const recurso = computed(
  () => SECOES.find(item => item.id === props.secao)?.recurso
);
const liberada = computed(() => Boolean(recursos.value?.[recurso.value]));
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="px-6">
      <div class="flex items-center w-full h-20 max-w-5xl gap-2 mx-auto">
        <span class="i-lucide-radio-tower size-5 text-n-slate-11" />
        <span class="text-heading-1 text-n-slate-12">
          {{ t(`NEUXS_NEXUS.ABAS.${secao}`) }}
        </span>
      </div>
    </header>
    <main class="flex-1 px-6 overflow-y-auto">
      <div class="w-full max-w-5xl py-4 mx-auto">
        <div v-if="recursos === null" class="flex justify-center py-10">
          <Spinner />
        </div>
        <p
          v-else-if="!liberada"
          class="p-4 text-sm rounded-xl bg-n-alpha-2 text-n-slate-11"
        >
          {{ t('NEUXS_NEXUS.SEM_SGP') }}
        </p>
        <component
          :is="COMPONENTES[secao]"
          v-else
          :key="`${secao}-${accountId}`"
          :account-id="accountId"
        />
      </div>
    </main>
  </section>
</template>
